<template>
  <div class="documentsWrapper">
    <span class="sectionTitle">Documents ({{ courriers.length }})</span>
    <div class="documentsGridWrapper">
      <div class="cardLayoutWrapper cardLayoutWrapper--header">
        <div class="elem elem--span-10 elem--nowrap">
          <span>Nature du courrier</span>
        </div>
        <div class="elem elem--span-14"></div>
        <div class="elem elem--span-5">
          <span>Date d'envoi</span>
        </div>
      </div>
      <div
        class="gridElemWrapper"
        v-for="(elem, index) in courriers"
        :key="index"
      >
        <div class="cardLayoutWrapper">
          <div class="elem elem--span-10 elem--bold">
            <span>{{ elem.nature }}</span>
          </div>
          <div class="elem elem--span-14"></div>
          <div class="elem elem--span-5">
            <span>{{ dateTimeToReadableDate(elem.dateDepot) }}</span>
          </div>
          <div class="elem elem--span-4">
            <BasicButton
              label="Télécharger"
              size="small"
              iconName="document-download"
              type="secondary"
              variant="outlined"
              @click="downloadDocument(endpoint, code, elem.id, elem.intitule)"
            />
          </div>
          <div class="elem elem--span-3"></div>
        </div>
      </div>
      <span
        v-if="!courriers.length"
        class="emptyListPlaceholder"
      >
        Aucun élément
      </span>
    </div>
    <div class="documentsMobileWrapper">
      <div
        class="documentsMobileElemWrapper"
        v-for="(elem, index) in courriersList"
        :key="index"
      >
        <div class="headerWrapper">
          <div class="leftContent">
            <span class="subtitle">{{ elem.nature }}</span>
            <span>Date d'envoi : {{ dateTimeToReadableDate(elem.dateDepot) }}</span>
          </div>
          <div class="rightContent">
            <BasicButton
              label="Télécharger"
              size="small"
              iconName="document-download"
              type="secondary"
              variant="outlined"
              @click="downloadDocument(endpoint, code, elem.id, elem.intitule)"
            />
          </div>
        </div>
      </div>
      <BasicButton
        v-if="courriers.length! > 3"
        @click="showFullCourriersList = !showFullCourriersList"
        variant="outlined"
        :label="!showFullCourriersList ? 'Déployer la liste' : 'Réduire la liste'"
        iconRight
        :iconName="!showFullCourriersList ? 'arrow-down' : 'arrow-up'"
      />
      <span
        v-if="!courriers.length"
        class="emptyListPlaceholder"
      >
        Aucun élément
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, computed } from 'vue';
  import type { CourrierDTO } from '@/features/api/extranet/dto/Facture/CourrierDTO'
  import type { Endpoint } from './UploadFiles.types'
  import { dateTimeToReadableDate } from '@/features/shared/tools'
  import { downloadDocument } from '@/features/services/detail/shared/DocumentsServices'

  const props = defineProps<{
    courriers: CourrierDTO[]
    code: string
    endpoint: Endpoint
  }>()

  const showFullCourriersList = ref(false)

  const courriersList = computed(() => {
    if (props.courriers.length! > 3 && !showFullCourriersList.value) {
      return props.courriers.slice(0, 3)
    }
    return props.courriers
  })
</script>

<style scoped lang="less">
  @import '../index.less';
</style>
